import { useCreateTravelDocumentPurchase } from 'api-hooks/order/travel-document';
import { TravelDocumentSalesModel } from 'api-hooks/sale/travel-document';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { SeparatorVertical } from 'legacy-modules/styles';
import React from 'react';
import { NavigationProps } from 'types';

import TravelDocumentOrderForm from './components/form';
import { DocumentPurchaseFormType } from './components/form-type';

export type TravelDocumentOrderCreateParams = {
  documentSale?: TravelDocumentSalesModel;
  defaultValues?: DocumentPurchaseFormType;
};

export default function TravelDocumentOrderCreate(
  props: NavigationProps<NavigationRoutes.DocumentPurchasesCreate>,
) {
  const { mutateAsync, error } = useCreateTravelDocumentPurchase();

  const onResolve = useApprovalableEdit('document-purchases');

  return (
    <>
      <TravelDocumentOrderForm
        {...props}
        travelDocumentSale={props.navigation.params?.documentSale}
        defaultValues={props.navigation.params?.defaultValues}
        renderError={
          !!error &&
          !!error.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )
        }
        onSubmit={async (input: any, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
